import URIS from 'constants/uris';
import http from 'services/http';

getTaxRates.operation = 'READ';
getTaxRates.idFrom = 'ARGS';
export function getTaxRates() {
  return http.get(`${URIS.TAXES}/rates`).then(({ data }) => data);
}
